import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CtBinaryOperator, CtModelConfiguration, CTModelDatatableFilter, CtModelOnFlyCreateService, CtModelRouteData, CtModelType, MaterialControlIcons } from '@ctsolution/ct-framework';
import { FeeTimeRepetitionAmountType } from 'projects/ct-manager/src/app/_core/enum/fee-time-repetition-amount-type';
import { ContactFeeRouteData } from 'projects/ct-manager/src/app/_core/route-data/contact-fee.route-data';

@Component({
  selector: 'contact-fee',
  templateUrl: './contact-fee.component.html',
  styleUrls: ['./contact-fee.component.scss']
})
export class ContactFeeComponent implements AfterViewInit {

  @Input() configuration: any | null = null;
  modelConfiguration: CtModelConfiguration<ContactFeeComponent> | null = null;
  @ViewChild('AmountCellTemplate') amountCellTemplate: TemplateRef<any> | null = null;

  constructor(private onFlyCreateHelper: CtModelOnFlyCreateService, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit() {

    this.setup();

  }

  async setup() {

    const routeData: CtModelRouteData = ContactFeeRouteData()
      .setModelType(CtModelType.DATATABLE);

    const configuration = CtModelConfiguration
      .create<any>()
      .setRouteData(routeData)
      .setOnCreate(() => this.openContactFeeForm())
      .setOnEdit((contactFee) => this.openContactFeeForm(contactFee.Oid))
      .setFieldsCustomTemplates([
        {
          prop: 'Amount',
          cellTemplate: this.amountCellTemplate
        },
      ])

    configuration
      .filterValues
      .addConstantFilter(
        CTModelDatatableFilter
          .create()
          .setField('Contact.Oid')
          .setValue(this.configuration?.Contact?.Oid)
          .setOperatorType(CtBinaryOperator.Equal)
      )

    this.modelConfiguration = configuration;

  }

  openContactFeeForm(Oid: number | null = null) {

    const routeData: CtModelRouteData = ContactFeeRouteData()
      .setModelType(CtModelType.FORM);

    const configuration: CtModelConfiguration<any> | null = CtModelConfiguration.create()

    if (Oid) {

      routeData
        .setId(Oid);

    }

    if (this.configuration?.Contact) {

      configuration
        .filterValues
        .addConstantFilter(
          CTModelDatatableFilter
            .create()
            .setField('Contact')
            .setValue(this.configuration.Contact)
            .setOperatorType(CtBinaryOperator.Equal)
        );

    }

    configuration
      .setRouteData(routeData);

    configuration
      .initialized()
      .subscribe(() => {

        setTimeout(() => {

          const form = configuration?.form;
          const amountTypeControl = form?.get('AmountType');
          const quantityControl = form?.get('Quantity');

          quantityControl?.disable();

          amountTypeControl
            ?.valueChanges
            .subscribe(value => {

              if (value === FeeTimeRepetitionAmountType.FixedForQuantity) {

                quantityControl?.enable()

              } else {

                quantityControl?.setValue(null);
                quantityControl?.disable();

              }

            })

        })

      })

    this.onFlyCreateHelper
      .openOnFlyCreate(configuration)
      .afterClosed()
      .subscribe((reload: any) => {

        if (reload) window.location.reload(); // dovrei usare la navigazione sul router, però non sta funzionando correttamente ... per ora facciamo refresh forzato

      });


  }
}
